export enum Role {
  Admin = 'Admin',
  Seller = 'Seller',
  Merchant = 'Merchant'
}
